import React, { useState } from 'react';
import { useFilter } from '../../../../hooks';
import { FilterField, OptionType } from './FilterField';

const FILTER_KEY = 'complianceStatus';

const complianceStatusOptions = [
  {
    title: 'Compliant',
    name: 'compliant',
  },
  {
    title: 'Not compliant',
    name: 'not-compliant',
  },
  {
    title: 'In progress',
    name: 'in-progress',
  },
  {
    title: 'In review',
    name: 'needs-review',
  },
];

export function ComplianceStatusFilter() {
  const { getFilterOptions, handleFilterChange } = useFilter(FILTER_KEY);
  const initialOptions = getFilterOptions(complianceStatusOptions);

  const [options, setOptions] = useState(initialOptions);

  function handleOptionSelect(selectedOption: OptionType) {
    const newOptions = options.map((option) =>
      option.name === selectedOption.name ? { ...option, selected: !option.selected } : option,
    );

    setOptions(newOptions);
    handleFilterChange(newOptions);
  }

  function handleOpen() {
    setOptions(initialOptions);
  }

  function handleSelectAll() {
    const newOptions = options.map((option) => ({ ...option, selected: true }));
    setOptions(newOptions);
    handleFilterChange(newOptions);
  }

  function handleOptionsClear() {
    const newOptions = options.map((option) => ({ ...option, selected: false }));
    setOptions(newOptions);
    handleFilterChange(newOptions);
  }

  return (
    <FilterField
      id="compliance-status-filter"
      title="Status"
      options={options}
      onAllOptionsSelect={handleSelectAll}
      onOptionSelect={handleOptionSelect}
      onOptionsClear={handleOptionsClear}
      onOpen={handleOpen}
    />
  );
}
